export default __webpack_public_path__ + "145b4782a1de7f4042db47fdfee4c0ff.png";